import apiUrl from '../../../constants'
import commonFunction from '../../../commonFunction'
import constantVariable from '../../../constantVariable'
import Vue from 'vue'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js';
import DatePicker from 'vue2-datepicker';

import {
	ModelListSelect,
	BasicSelect
} from 'vue-search-select';
import FileUpload from 'v-file-upload';

import moment from 'moment';
import JQuery from 'jquery';
let $ = JQuery


Vue.use(FileUpload);
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.filter('formatDate', function (value) {

	if (value) {
		return moment(String(value)).format('DD-MM-YYYY hh:mm')
	}

});

export default {
	name: 'allReports',
	components: {
		Paginate,
		DatePicker,
		ModelListSelect,
		BasicSelect,
		Loading
	},
	data() {
		return {
			showList: 0,
			listTotalCount: 0,
			page: 'allReports',
			tableDataKeys:[],
			tableData: [],
			search: {
				tableId:'',
				searchDate: new Date(),
				shippingId:''
			},
			tableList: [{
				value: "csawdetails",
				text: "CSAW Details"
			}, {
				value: "autonextdayattempt",
				text: "Auto Next Day Attempt"
			},{
				value: "logs",
				text: "Logs"
			}, {
				value: "ticketlog",
				text: "Ticket Logs"
			}],
      selectedTableObj: {},
			isLoading:false,
			fullPage: false,
			fieldHider:true
		}
	},
	created: function () {
	 },

	computed: {

	},

	filters: {
		moment: function (date) {
			if (!date)
				return;
			return moment(date).format('DD-MM-YYYY');
		},
		momentdate: function (date) {
			if (!date)
				return;
			return moment(date).format('DD-MM-YYYY');
		},
		momenttime: function (date) {
			if (!date)
				return;
			return moment(date).format('HH:mm');
		}
	},
	mounted() {
		[this.subDepartmentList, this.DepartmentID,this.userdetail,this.userTypeForTicket]=commonFunction.getuserDetailsAndpermissionData();

		this.userid =  this.userdetail[0].userid;
		this.username =  this.userdetail[0].username;
        this.userRole = this.userdetail[0].roles[0].rolename;

		// console.log( 'DepartmentID : '+this.DepartmentID);

		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss');

	}, // End computed
	methods: {
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') ;
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).add(1, 'd').format('YYYY-MM-DD') ;
		},

		selectedTableName(ticketTableData) {
			this.search.shippingId='';
			this.showList = 0;
      this.selectedTableObj = ticketTableData;
      this.search.tableId = ticketTableData.value.toString();
			if(this.search.tableId=='csawdetails'){
				this.fieldHider=false;
			}
			else{
				this.fieldHider=true;
			}
    },

getAllReports() {
	try{
	var userToken = window.localStorage.getItem('userToken');
	var myStr = userToken.replace(/"/g, '');
	var searchData = {};
	this.isLoading = true;
	this.listTotalCount = 0;
	let searchDate=new Date();
		searchDate = commonFunction.reformatDateString(searchDate.toLocaleDateString());
		searchData = {
			tableId: this.search.tableId,
			searchDate: searchDate,
			shippingId: this.search.shippingId
		}
	axios({
			method: 'POST',
			'url': apiUrl.api_url + 'getAllReports',
			'headers': commonFunction.getusertoken(),
			'data': searchData,
		})
		.then(result => {
			this.isLoading = false;
			if (result.data.data) {
				this.showList = 1;
				this.tableData = result.data.data.data;
				this.listTotalCount = this.tableData.length;
				if(this.tableData.length !== 0){
				 this.tableDataKeys = Object.keys(this.tableData[0]);
					}
			} else {
				this.$alertify.error("API Error");
			}
		}, error => {
			this.isLoading = false;
			var commonVariable=commonFunction.showNetworkError(error);
			this.$alertify.error(commonVariable);
		});
	}
	catch (error) {
		this.isLoading = false;
		let msg = error+" - getAllReports";
		this.$alertify.error(msg);
	}
},

searchButton() {
	if(this.search.tableId==''){
	this.$alertify.error("Please Select Table Name");
	return false;
	 }
	this.getAllReports();
},

	 resetForm() {
		this.showList = 0;
		var self = this; //you need this because *this* will refer to Object.keys below`
		this.listTotalCount = 0;
		this.tableData = [];
		this.search = {
			tableId:'',
			shippingId:''
		};
		this.selectedTableObj.value ='';
		this.selectedTableObj.text ='';
		this.search.tableId='';
		this.search.shippingId='';
	},
	} // end methods
}



// WEBPACK FOOTER //
// ./src/views/components/allReports/allReports.component.js